<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/areamange/add')">新增</el-button>
      </template>
      <el-form :model="searchForm" ref="searchForm" inline class="global-form-label-width account-form"
        label-width="100px">
        <el-form-item prop="areaName" label="区域名称">
          <el-input v-model="searchForm.areaName" placeholder="请输入区域名称" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="120" label="区域名称" prop="areaName"></el-table-column>

        <el-table-column width="180" label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" @click=" $router.push('/areamange/detail?areaId=' + row.areaId)">详情</el-button>
            <el-button type="text" v-if="hasEdit" @click="$router.push('/areamange/edit?areaId=' + row.areaId)">编辑</el-button>
            <el-button v-if="hasDel" type="text" @click="deleteRow(row.areaId)" class="del-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>

  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'

export default {
  name: 'AreaMange',
  mixins: [keepAlive],

  data() {
    return {
      tableData: [],
      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        areaName: ''
      }
    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    deleteRow(areaId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.wspb.deletePaFactoryArea, {
          areaId
        }).then(() => {
          this.loadData()
        })
      })
    },
    loadData() {
      this.$axios.get(this.$apis.wspb.selectPaFactoryAreaByPage, {
        ...this.searchForm,
        page: this.page,
        size: 10
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.$refs.searchForm.resetFields()
      this.onSearch()
    }
  }
}
</script>
<style lang="scss" scoped></style>
